import { useEffect } from "react"

import { Box } from "@chakra-ui/react"
import { Link, useSearchParams } from "react-router-dom"

import { useAppDispatch, useAppSelector } from "app/hooks"
import WhimstayIcon from "components/icons/rbo/WhimstayIcon"
import NavigationRadioList from "pages/listing-details-with-step/src/left-section/navigation-radio-list"
import PropertyCardSkeleton from "pages/listing-details-with-step/src/left-section/property-card-skeleton"
import {
  getOnBoardingStatusDataApi,
  selectPropertiesData,
} from "store/rbo/rboSlice"

import { useExtractPathDetails } from "../common"
import PropertyDetails from "./property-details"

// This is the left section of the listing details page. It shows the listing details and images.
const LeftSectionForListingDetails = ({
  setSidebarOpen,
}: {
  setSidebarOpen?: (isOpen: boolean) => void
}) => {
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const propertiesData = useAppSelector(selectPropertiesData)
  const { pageName } = useExtractPathDetails() // Get propertyId from the URL
  const property = propertiesData?.property

  // fetch get onboarding status data API call
  useEffect(() => {
    if (searchParams?.get("propertyId") || property?.id) {
      dispatch(
        getOnBoardingStatusDataApi({
          params: {
            propertyId: searchParams?.get("propertyId") || property?.id || "",
          },
        }),
      ).catch(() => {})
    }
  }, [dispatch, searchParams, property?.id, pageName])

  return (
    <>
      <Box mb={{ base: 4, sm: "18px" }} mt='22px' px={3}>
        <Link to='/'>
          <WhimstayIcon />
        </Link>
      </Box>
      <Box
        bg='white'
        mx={{ base: 4, sm: "50px" }}
        px={{ base: 4, sm: "24px" }}
        py={4}
        borderRadius='16px'
        mb={6}
      >
        {propertiesData === undefined ? (
          <PropertyCardSkeleton />
        ) : (
          <PropertyDetails property={property} />
        )}
      </Box>
      <NavigationRadioList setSidebarOpen={setSidebarOpen} />
    </>
  )
}
export default LeftSectionForListingDetails
